var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2381_139489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.5415H21V10.5H12V14.5H17.6515C16.827 16.8285 14.6115 18.5 12 18.5C8.6865 18.5 6 15.8135 6 12.5C6 9.1865 8.6865 6.5 12 6.5C13.5295 6.5 14.921 7.077 15.9805 8.0195L18.809 5.191C17.023 3.5265 14.634 2.5 12 2.5C6.4775 2.5 2 6.9775 2 12.5C2 18.0225 6.4775 22.5 12 22.5C17.5225 22.5 22 18.0225 22 12.5C22 11.8295 21.931 11.175 21.8055 10.5415Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15332 7.8455L6.43882 10.255C7.32782 8.054 9.48082 6.5 12.0003 6.5C13.5298 6.5 14.9213 7.077 15.9808 8.0195L18.8093 5.191C17.0233 3.5265 14.6343 2.5 12.0003 2.5C8.15932 2.5 4.82832 4.6685 3.15332 7.8455Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 22.5001C14.5832 22.5001 16.9302 21.5116 18.7047 19.9041L15.6097 17.2851C14.5719 18.0743 13.3039 18.5011 12.0002 18.5001C9.39916 18.5001 7.19066 16.8416 6.35866 14.5271L3.09766 17.0396C4.75266 20.2781 8.11366 22.5001 12.0002 22.5001Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.5415H21V10.5H12V14.5H17.6515C17.2571 15.6082 16.5467 16.5766 15.608 17.2855L15.6095 17.2845L18.7045 19.9035C18.4855 20.1025 22 17.5 22 12.5C22 11.8295 21.931 11.175 21.8055 10.5415Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2381_139489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b0fcb935760d034f13f87a384681b92e.svg";
export { ForwardRef as ReactComponent };